import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-news-embed-button',
  templateUrl: './news-embed-button.component.html',
  styleUrls: ['./news-embed-button.component.scss']
})
export class NewsEmbedButtonComponent implements OnInit {

  public text: string;
  public url: string;
  public target = "_blank";
  public color = "#fff";
  public background = "#19132F";

  constructor() { }

  ngOnInit() {
    console.log('Embed button: ', this.text, this.color, this.background, this.url)
  }

}
